<div class="page">
  <app-page-header page-title="tank.list.pageTitle">
  </app-page-header>
  <div class="page-content">
    <mat-card class="custom-card">
      <div class="row">
        <div class="col-12 d-flex">
          <mat-card-title>{{ 'tank.list.title' | translate }}
          </mat-card-title>
          <button class="navigation-button ml-4" mat-flat-button (click)="onOpenAddDocDialog()" color="primary"
            *ngIf="currentRole === 'master' || currentRole === 'collaborator'">
            <mat-icon fontSet="fal" fontIcon="fa-plus"></mat-icon>
            {{ 'common.cta.add' | translate }}
          </button>
        </div>
      </div>
      <mat-card-content [ngClass]="{ 'search-area-loading': documentArchiveIsLoading }">
        <div class="row">
          <div class="col-12">
            <div class="table-wrapper">
              <div class="table-toolbar">
                <div class="row align-items-center">
                  <div class="col-12 col-sm-6 col-md-6">
                    <!--
                      <mat-form-field>
                      <input matInput placeholder="{{ 'common.words.search' | translate }}" #input>
                      <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="resetInput()"
                        class="reset-input-icon" *ngIf="input.value"></mat-icon>
                    </mat-form-field> -->
                  </div> <!-- /.col-12.col-md-4 -->
                  <div class="col-12 col-sm-6 col-md-6 text-right">
                    <button mat-button (click)="onResetFilters()" class="d-none d-sm-inline-block">
                      <mat-icon fontSet="fal" fontIcon="fa-broom"></mat-icon>
                      {{ 'common.cta.resetFilters' | translate }}
                    </button>
                  </div> <!-- /.col-12.col-md-8 -->
                </div> <!-- /.row -->
              </div> <!-- /.table-toolbar -->
              <div class="spinner-container" *ngIf="dataSource.loading$ | async">
                <mat-spinner strokeWidth="3" [diameter]="50" mode="indeterminate"></mat-spinner>
              </div> <!-- /.spinner-container -->
              <div class="table-responsive">
                <table mat-table [dataSource]="dataSource" matSort #sort1="matSort" matSortActive="createdAt"
                  matSortDirection="desc" matSortDisableClear class="mat-elevation-z0">
                  <ng-container matColumnDef="index">
                    <th mat-header-cell *matHeaderCellDef class="col-fixed-xxs">#</th>
                    <td mat-cell *matCellDef="let element; let i = index">
                      {{ i + 1 }}
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <ng-container matColumnDef="condo">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ 'tank.fields.condo' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.condo }}
                    </td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                        <input matInput [formControl]="condoFilter">
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(condoFilter)"
                          class="reset-input-icon" *ngIf="condoFilter.value"></mat-icon>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="name">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ 'tank.fields.name' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      {{ element.name }}
                    </td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                        <input matInput [formControl]="nameFilter">
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(nameFilter)"
                          class="reset-input-icon" *ngIf="nameFilter.value"></mat-icon>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="company">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>
                      {{ 'tank.fields.company' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <a routerLink="../../companies/detail/{{ element.company?._id}}">
                        {{ element.company?.name }}
                      </a>
                    </td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.words.search' | translate }}</mat-label>
                        <input type="text" matInput [formControl]="companyFilter" [matAutocomplete]="companyAuto">
                        <mat-autocomplete autoActiveFirstOption #companyAuto="matAutocomplete"
                          [displayWith]="displayCompanyFn.bind(this)"
                          (onSelectionChange)="onCompanyFilterSelected($event)">
                          <mat-option *ngIf="companyIsLoading" class="is-loading">
                            <mat-spinner diameter="50"></mat-spinner>
                          </mat-option>
                          <ng-container *ngIf="!companyIsLoading">
                            <mat-option *ngFor="let company of availableCompanies" [value]="company"
                              (onSelectionChange)="onCompanyFilterSelected($event)">
                              <small>{{ company.name }}</small>
                            </mat-option>
                          </ng-container>
                        </mat-autocomplete>
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(companyFilter)"
                          class="reset-input-icon" *ngIf="companyFilter.value"></mat-icon>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="viewed">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header class="col-width col-width-10">
                      {{ 'tank.fields.viewed' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">
                      <span *ngIf="element.viewed">
                        {{ 'common.words.yes' | translate }}
                      </span>
                      <span *ngIf="!element.viewed">
                        {{ 'common.words.no' | translate }}
                      </span>
                    </td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                        <mat-select [formControl]="viewedFilter">
                          <mat-option *ngFor="let viewed of availableStatus" [value]="viewed">
                            <small>{{ 'tank.viewed.' + viewed | translate }}</small>
                          </mat-option>
                        </mat-select>
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(viewedFilter)"
                          class="reset-input-icon" *ngIf="viewedFilter.value"></mat-icon>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="createdAt">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>{{ 'tank.fields.createdAt' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element">{{ element.createdAt | dateFormat }}</td>
                    <td mat-footer-cell *matFooterCellDef>
                      <mat-form-field class="filter">
                        <mat-label>{{ 'common.cta.select' | translate }}</mat-label>
                        <input matInput [matDatepicker]="dp" (focus)="dp.open()" (click)="dp.open()" readonly
                          placeholder="{{ 'common.cta.select' | translate }}" [formControl]="createdAtFilter"
                          style="cursor: pointer" />
                        <mat-icon matSuffix fontSet="fal" fontIcon="fa-times" (click)="onResetFilter(createdAtFilter)"
                          class="reset-input-icon" *ngIf="createdAtFilter.value"></mat-icon>
                        <mat-datepicker-toggle matSuffix [for]="dp"></mat-datepicker-toggle>
                        <mat-datepicker #dp></mat-datepicker>
                      </mat-form-field>
                    </td>
                  </ng-container>
                  <ng-container matColumnDef="actions">
                    <th mat-header-cell *matHeaderCellDef class="text-right pr-5">{{ 'common.cta.actions' | translate }}
                    </th>
                    <td mat-cell *matCellDef="let element" class="text-right">
                      <button mat-raised-button color="primary" (click)="onOpenEditDocDialog(element)"
                        matTooltip="{{ 'common.words.clickToOpen' | translate }}">
                        {{ 'common.cta.open' | translate }}
                        <mat-icon fontSet="fal" fontIcon="fa-external-link"></mat-icon>
                      </button>
                    </td>
                    <td mat-footer-cell *matFooterCellDef></td>
                  </ng-container>
                  <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                  <tr mat-row *matRowDef="let row; columns: displayedColumns; let i = index;"
                    [class.even-row]="(i % 2) == 0"></tr>
                  <tr mat-footer-row *matFooterRowDef="displayedColumns"></tr>
                </table>
                <mat-paginator [length]="dataSource.totalCount$ | async" [pageSizeOptions]="[10, 15, 20, 50, 75, 100]"
                  showFirstLastButtons></mat-paginator>
              </div> <!-- /.table-responsive -->
            </div> <!-- /.table-wrapper -->

          </div> <!-- /.col -->
        </div> <!-- /.row -->
      </mat-card-content>
    </mat-card>
  </div> <!-- /.page-content -->
</div> <!-- /.page -->